import classNames from "classnames";
import type { ReactNode } from "react";
import Badge from "@/components/Badge/Badge";

export interface RowHeaderProps {
  label: string;
  count?: number;
  columnCount: number;
  testId?: string;
  rowTestId?: string;
  className?: string;
  trailing?: ReactNode;
}

export default function RowHeader({
  label,
  count,
  columnCount,
  testId,
  rowTestId = "table-row-header",
  className,
  trailing
}: RowHeaderProps) {
  return (
    <tr
      className={classNames(
        "border-t border-sys-brand-surface-container-highest bg-sys-brand-surface-container-high",
        className
      )}
      data-testid={rowTestId}
    >
      <td colSpan={columnCount} className={classNames("align-middle", trailing ? "min-h-12 py-2" : "h-12")}>
        <div className="flex min-w-0 flex-wrap items-center gap-x-2 gap-y-1">
          <span className="shrink-0 text-label-medium uppercase tracking-widest text-sys-brand-on-surface-variant">
            {label}
          </span>
          {count != null && <Badge value={count} testId={testId} />}
          {trailing ? <div className="ml-auto shrink-0 text-right normal-case tracking-normal">{trailing}</div> : null}
        </div>
      </td>
    </tr>
  );
}
